import React, { useState } from 'react';
import { Home, Calendar, Star, Crown, Coffee, Bed, Users, Phone, Clock, Sun, Heart, Sparkles, Award, Gift, Waves, Umbrella } from 'lucide-react';

const SunnyBlondeHouseApp = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [bookingData, setBookingData] = useState({
    name: '',
    dates: '',
    package: '',
    specialRequests: ''
  });
  const [bookings, setBookings] = useState([
    { date: '2025-07-01', guest: 'Marco', status: 'confirmed', package: 'Principe del Divano' },
    { date: '2025-07-05', guest: 'Giulia', status: 'pending', package: 'Regina della Cucina' },
    { date: '2025-07-10', guest: 'Luca', status: 'confirmed', package: 'Duca del Weekend' }
  ]);

  const vipPackages = [
    {
      id: 1,
      name: "Duca del Weekend",
      subtitle: "(Padrone della casa per 48 ore)",
      price: "Prosecco + Pizza",
      duration: "Weekend Completo",
      icon: <Gift className="w-6 h-6" />,
      features: [
        "Accesso VIP a tutte le stanze (compresa quella segreta)",
        "Diritto di organizzare feste improvvisate",
        "Servizio maggiordomo supremo",
        "Colazione, pranzo e cena inclusi (a tue spese)",
        "WiFi password segreta svelata",
        "Certificato di 'Miglior Ospite dell'Anno'"
      ],
      color: "from-blue-400 to-navy-800",
      payment: "Una bottiglia di prosecco + pizza per tutti",
      category: "interno"
    },
    {
      id: 2,
      name: "Regina della Cucina",
      subtitle: "(Chef suprema della casa)",
      price: "2 Dolci Fatti in Casa",
      duration: "Weekend",
      icon: <Star className="w-6 h-6" />,
      features: [
        "Accesso illimitato al frigorifero",
        "Diritto di cucinare quello che vuoi",
        "Posto d'onore a tavola",
        "Nessun obbligo di lavare i piatti",
        "Ricettario segreto della nonna (fotocopia)",
        "Grembiule con scritta 'Head Chef'"
      ],
      color: "from-pink-400 to-rose-500",
      payment: "Due dolci fatti in casa (no mulino bianco)",
      category: "interno"
    },
    {
      id: 3,
      name: "Principe del Divano",
      subtitle: "(Dignità nobiliare inclusa nel prezzo)",
      price: "1 Bottiglia di Vino",
      duration: "1 Giorno",
      icon: <Crown className="w-6 h-6" />,
      features: [
        "Controllo esclusivo del telecomando TV",
        "Posto fisso sul divano migliore",
        "Servizio colazione a letto (se te la fai da solo)",
        "Diritto di veto sui film horror",
        "Corona di cartone personalizzata",
        "Cuscino con ricamo del tuo nome"
      ],
      color: "from-purple-400 to-purple-600",
      payment: "Una bottiglia di vino decente (no brick da 2€)",
      category: "interno"
    },
    {
      id: 8,
      name: "Maggiordomo Supremo",
      subtitle: "(L'ospite che fa tutto ma si sente un re)",
      price: "La Tua Energia + Buonumore",
      duration: "Fino a Sfinimento",
      icon: <Award className="w-6 h-6" />,
      features: [
        "Privilegio di cucinare per tutti (che onore!)",
        "Diritto esclusivo di lavare i piatti (che fortuna!)",
        "Servizio pulizie personalizzato (solo per te!)",
        "Responsabilità della spesa alimentare (che fiducia!)",
        "Ruolo di barista ufficiale (che prestigio!)",
        "Certificato di 'Miglior Servitore VIP' (incorniciato!)"
      ],
      color: "from-emerald-400 to-green-600",
      payment: "Il tuo sudore, le tue lacrime, e un sorriso",
      category: "interno"
    },
    {
      id: 4,
      name: "Imperatore della Terrazza",
      subtitle: "(Regnante supremo del sole e della piscina)",
      price: "1 Bottiglia di Prosecco",
      duration: "Giornata Intera",
      icon: <Sun className="w-6 h-6" />,
      features: [
        "Controllo esclusivo della temperatura piscina",
        "Lettino premium con vista panoramica",
        "Diritto di primo tuffo della giornata",
        "Playlist musicale personalizzata",
        "Servizio cocktail su richiesta (fatto da te)",
        "Corona da bagno impermeabile"
      ],
      color: "from-yellow-400 to-orange-500",
      payment: "Una bottiglia di prosecco (no fragolino)",
      category: "terrazza"
    },
    {
      id: 5,
      name: "Baronessa dell'Aperitivo",
      subtitle: "(Master mixologist della casa)",
      price: "Aperitivi per Tutti",
      duration: "Dalle 17:00 in poi",
      icon: <Sparkles className="w-6 h-6" />,
      features: [
        "Accesso VIP al mini-bar della terrazza",
        "Diritto di preparare gli aperitivi per tutti",
        "Posto fisso all'ombra dell'ombrellone",
        "Playlist 'Golden Hour' dedicata",
        "Responsabile degli stuzzichini",
        "Bicchiere personalizzato con nome inciso"
      ],
      color: "from-orange-400 to-pink-500",
      payment: "Ingredienti per aperitivi di gruppo",
      category: "terrazza"
    },
    {
      id: 6,
      name: "Conte delle Bolle",
      subtitle: "(Esperto di bollicine e relax acquatico)",
      price: "Champagne + Snacks",
      duration: "Weekend Completo",
      icon: <Waves className="w-6 h-6" />,
      features: [
        "Accesso h24 alla piscina (anche di notte se sei coraggioso)",
        "Diritto di organizzare pool party spontanei",
        "Materassino gonfiabile personalizzato",
        "Servizio champagne a bordo piscina",
        "Istruttore di nuoto autoproclamato",
        "Medaglia di 'Miglior Tuffatore' (anche se sai solo fare il cagnolino)"
      ],
      color: "from-blue-400 to-navy-800",
      payment: "Bottiglia di champagne + snacks gourmet",
      category: "terrazza"
    },
    {
      id: 7,
      name: "Duchessa del Tramonto",
      subtitle: "(Esperta di momenti Instagram-abili)",
      price: "Prosecco + Foto",
      duration: "Ora del Tramonto",
      icon: <Heart className="w-6 h-6" />,
      features: [
        "Posto migliore per vedere il tramonto",
        "Servizio fotografico professionale (con il mio telefono)",
        "Accesso ai filtri Instagram premium della casa",
        "Diritto di scegliere la musica romantica",
        "Servizio prosecco con tramonto incluso",
        "Certificato di 'Migliore Influencer della Terrazza'"
      ],
      color: "from-purple-400 to-pink-400",
      payment: "Bottiglia di prosecco + fare da fotografa per gli altri",
      category: "terrazza"
    }
  ];

  const terrazzePackages = vipPackages.filter(pkg => pkg.category === 'terrazza');
  const internoPackages = vipPackages.filter(pkg => pkg.category === 'interno');

  const TabButton = ({ id, label, icon, active, onClick }) => (
    <button
      onClick={() => onClick(id)}
      className={`relative flex flex-col items-center p-4 rounded-xl transition-all duration-300 overflow-hidden group ${
        active 
          ? 'text-white shadow-xl transform scale-105' 
          : 'text-navy-600 hover:text-navy-800 hover:shadow-md hover:scale-102'
      }`}
    >
      {/* Background per tab attivo */}
      {active && (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-blue-500 to-navy-500"></div>
          <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/20 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-yellow-400 to-blue-300"></div>
        </>
      )}
      
      {/* Background per tab inattivo */}
      {!active && (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-white via-blue-50/50 to-purple-50/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div className="absolute inset-0 bg-white/80 backdrop-blur-sm"></div>
        </>
      )}
      
      {/* Contenuto */}
      <div className="relative z-10 flex flex-col items-center">
        <div className={`${active ? 'drop-shadow-lg' : ''} transition-all duration-300`}>
          {icon}
        </div>
        <span className={`text-xs mt-2 font-semibold ${active ? 'drop-shadow-sm' : ''} transition-all duration-300`}>
          {label}
        </span>
      </div>
      
      {/* Effetto glow per tab attivo */}
      {active && (
        <div className="absolute inset-0 bg-gradient-to-r from-blue-400/30 via-transparent to-navy-500/30 blur-sm"></div>
      )}
    </button>
  );

  const PackageCard = ({ pkg, onSelect }) => (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden border-2 border-navy-200 hover:shadow-xl hover:border-navy-300 transition-all duration-300">
      <div className={`h-20 bg-gradient-to-r ${pkg.color} flex items-center justify-center relative overflow-hidden`}>
        <div className="text-white text-3xl z-10">
          {pkg.icon}
        </div>
        <div className="absolute inset-0 bg-black bg-opacity-10"></div>
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
          <div>
            <h3 className="font-bold text-navy-800 text-lg">{pkg.name}</h3>
            <p className="text-navy-500 text-sm italic">{pkg.subtitle}</p>
          </div>
          <div className="text-right">
            <div className="text-lg font-bold text-navy-800">{pkg.price}</div>
            <div className="text-navy-500 text-sm">{pkg.duration}</div>
          </div>
        </div>
        <ul className="space-y-2 mb-4">
          {pkg.features.map((feature, index) => (
            <li key={index} className="flex items-start text-sm text-navy-600">
              <Star className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
              {feature}
            </li>
          ))}
        </ul>
        <div className="bg-navy-50 p-3 rounded-lg mb-4">
          <p className="text-xs text-navy-600">
            <strong>Pagamento richiesto:</strong> {pkg.payment}
          </p>
        </div>
        <button
          onClick={() => onSelect(pkg)}
          className={`w-full bg-gradient-to-r ${pkg.color} text-white py-3 rounded-lg hover:opacity-90 transition-all duration-200 font-medium shadow-md hover:shadow-lg transform hover:scale-105`}
        >
          Prenota la tua Experience!
        </button>
      </div>
    </div>
  );

  const renderContent = () => {
    switch(activeTab) {
      case 'home':
        return (
          <div className="space-y-6">

            {/* Pacchetti Terrazza & Piscina */}
            <div className="relative text-center rounded-2xl overflow-hidden mb-6">
              {/* Background migliorato */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500 via-navy-600 to-blue-700"></div>
              <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/25 via-transparent to-blue-300/15"></div>
              
              {/* Effetti decorativi leggeri */}
              <div className="absolute top-4 right-8 w-20 h-20 bg-yellow-300/20 rounded-full blur-xl"></div>
              <div className="absolute bottom-4 left-8 w-16 h-16 bg-blue-300/25 rounded-full blur-lg"></div>
              
              {/* Contenuto */}
              <div className="relative z-10 p-8">
                <div className="flex justify-center items-center mb-6">
                  <div className="relative">
                    <Sun className="w-14 h-14 mr-4 text-yellow-300 drop-shadow-lg" />
                    <div className="absolute inset-0 w-14 h-14 mr-4 bg-yellow-300/30 rounded-full blur-md"></div>
                  </div>
                  <div className="relative">
                    <Waves className="w-24 h-24 text-blue-200 drop-shadow-lg transform hover:scale-105 transition-transform duration-300" />
                    <div className="absolute inset-0 w-18 h-18 bg-blue-200/30 rounded-full blur-lg"></div>
                  </div>
                  <div className="relative">
                    <Umbrella className="w-14 h-14 ml-4 text-yellow-300 drop-shadow-lg" />
                    <div className="absolute inset-0 w-14 h-14 ml-4 bg-yellow-300/30 rounded-full blur-md"></div>
                  </div>
                </div>
                <h1 className="text-4xl font-black text-white mb-3 drop-shadow-xl">Pacchetti Terrazza & Piscina VIP</h1>
                <p className="text-blue-100 text-lg font-medium drop-shadow-md">
                  Dove il sole splende sempre... <br />
                  <span className="text-sm italic opacity-90">(e dove gli aperitivi scorrono a fiumi)</span>
                </p>
              </div>
              
              {/* Bordo luminoso */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-400 to-blue-400"></div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {terrazzePackages.map((pkg) => (
                <PackageCard key={pkg.id} pkg={pkg} onSelect={setSelectedPackage} />
              ))}
            </div>

            <div className="bg-navy-50 p-6 rounded-xl border-2 border-navy-200">
              <h3 className="font-bold text-navy-800 mb-3 flex items-center">
                <Waves className="w-5 h-5 mr-2 text-blue-600" />
                Note Importanti per la Terrazza
              </h3>
              <ul className="space-y-2 text-navy-600 text-sm">
                <li>• <strong>ACCESSO PISCINA:</strong> solo dopo "tributo" in bevande alcoliche</li>
                <li>• <strong>ORE 18:00 APERITIVO SACRO:</strong> ritardatari pagano penale in Spritz</li>
                <li>• Le foto per Instagram sono concesse solo a pagamento e devono taggarmi (@sunnyblondehouse)</li>
                <li>• Il fenicottero gonfiabile è di proprietà della casa</li>
                <li>• La crema solare non è inclusa</li>
                <li>• Chi sporca la piscina pulisce la piscina (con spazzolino da denti)</li>
                <li>• I lettini migliori si guadagnano con merito (o con tangenti in champagne)</li>
                <li>• Chi finisce il ghiaccio deve comprarne 3 sacchi (regola del karma)</li>
              </ul>
            </div>

            {/* Pacchetti Casa VIP */}
            <div className="relative text-center rounded-2xl overflow-hidden mb-6">
              {/* Background migliorato */}
              <div className="absolute inset-0 bg-gradient-to-br from-pink-500 via-purple-600 to-navy-700"></div>
              <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/20 via-transparent to-pink-300/15"></div>
              
              {/* Effetti decorativi leggeri */}
              <div className="absolute top-4 left-8 w-18 h-18 bg-pink-300/25 rounded-full blur-xl"></div>
              <div className="absolute bottom-4 right-8 w-16 h-16 bg-yellow-300/20 rounded-full blur-lg"></div>
              
              {/* Contenuto */}
              <div className="relative z-10 p-8">
                <div className="relative mb-6">
                  <Crown className="w-20 h-20 mx-auto text-yellow-400 drop-shadow-xl transform hover:scale-110 transition-transform duration-300" />
                  <div className="absolute inset-0 w-20 h-20 mx-auto bg-yellow-400/40 rounded-full blur-lg"></div>
                </div>
                <h1 className="text-4xl font-black text-white mb-3 drop-shadow-xl">Pacchetti Casa interna VIP</h1>
                <p className="text-pink-100 text-lg font-medium drop-shadow-md">
                  Per chi ama il comfort domestico<br />
                  <span className="text-sm italic opacity-90">(e il controllo del telecomando)</span>
                </p>
              </div>
              
              {/* Bordo luminoso */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-pink-400 to-purple-500"></div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {internoPackages.map((pkg) => (
                <PackageCard key={pkg.id} pkg={pkg} onSelect={setSelectedPackage} />
              ))}
            </div>

            <div className="bg-navy-50 p-6 rounded-xl border-2 border-navy-200">
              <h3 className="font-bold text-navy-800 mb-3 flex items-center">
                <Home className="w-5 h-5 mr-2 text-navy-600" />
                Note importanti per la Casa
              </h3>
              <ul className="space-y-2 text-navy-600 text-sm">
                <li>• <strong>ACCESSO TERRAZZA/PISCINA:</strong> 1 bottiglia prosecco o snacks gourmet</li>
                <li>• <strong>CONTRIBUTO APERITIVI:</strong> obbligatorio per accesso al tramonto VIP</li>
                <li>• Il divano ha un posto migliore, si assegna per merito (o per corruzione)</li>
                <li>• Chi cucina non lava i piatti (legge universale)</li>
                <li>• I Maggiordomi Supremi lavorano con il sorriso (è nel contratto)</li>                
                <li>• I doni al Padrone di casa garantiscono upgrade automatico del pacchetto</li>
              </ul>
            </div>

          </div>
        );

      case 'terrazza':
        return (
          <div className="space-y-6">
            <div className="text-center bg-gradient-to-r from-blue-400 via-navy-500 to-blue-600 text-white p-8 rounded-2xl relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-300/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="flex justify-center items-center mb-4">
                  <Sun className="w-12 h-12 mr-3 text-yellow-300" />
                  <Waves className="w-12 h-12 text-blue-200" />
                  <Umbrella className="w-12 h-12 ml-3 text-yellow-300" />
                </div>
                <h1 className="text-3xl font-bold mb-2">Pacchetti Terrazza & Piscina VIP</h1>
                <p className="text-blue-100 text-lg">
                  Dove il sole splende sempre... <br />
                  <span className="text-sm italic">(e dove gli aperitivi scorrono a fiumi)</span>
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {terrazzePackages.map((pkg) => (
                <PackageCard key={pkg.id} pkg={pkg} onSelect={setSelectedPackage} />
              ))}
            </div>
          </div>
        );

      case 'calendar':
        return (
          <div className="space-y-6">
            <h1 className="text-2xl font-bold text-navy-800 mb-6 flex items-center">
              <Calendar className="w-8 h-8 mr-3 text-navy-600" />
              Calendario delle Prenotazioni VIP
            </h1>
            
            <div className="bg-white p-6 rounded-xl shadow-md border-2 border-navy-200">
              <h2 className="text-lg font-semibold text-navy-800 mb-4">Prenotazioni Attuali</h2>
              <div className="space-y-3">
                {bookings.map((booking, index) => (
                  <div key={index} className="flex items-center justify-between p-4 bg-navy-50 rounded-lg border border-navy-200">
                    <div className="flex items-center">
                      <Calendar className="w-5 h-5 text-navy-600 mr-3" />
                      <div>
                        <div className="font-medium text-navy-800">{booking.guest}</div>
                        <div className="text-sm text-navy-600">{booking.package}</div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-navy-800 font-medium">{booking.date}</div>
                      <div className={`text-sm px-2 py-1 rounded-full ${
                        booking.status === 'confirmed' 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-yellow-100 text-yellow-700'
                      }`}>
                        {booking.status === 'confirmed' ? 'Confermato' : 'In Attesa'}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-navy-50 p-6 rounded-xl border-2 border-navy-200">
              <h2 className="text-lg font-semibold text-navy-800 mb-4">Nuova Prenotazione</h2>
              <div className="space-y-4">
                <input
                  type="text"
                  placeholder="Il tuo nome (titolo nobiliare opzionale)"
                  value={bookingData.name}
                  onChange={(e) => setBookingData({...bookingData, name: e.target.value})}
                  className="w-full p-3 border-2 border-navy-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-transparent"
                />
                <input
                  type="date"
                  value={bookingData.dates}
                  onChange={(e) => setBookingData({...bookingData, dates: e.target.value})}
                  className="w-full p-3 border-2 border-navy-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-transparent"
                />
                <select
                  value={bookingData.package}
                  onChange={(e) => setBookingData({...bookingData, package: e.target.value})}
                  className="w-full p-3 border-2 border-navy-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-transparent"
                >
                  <option value="">Scegli il tuo pacchetto VIP</option>
                  {vipPackages.map(pkg => (
                    <option key={pkg.id} value={pkg.name}>{pkg.name}</option>
                  ))}
                </select>
                <textarea
                  placeholder="Richieste speciali (entro limiti del ragionevole)"
                  rows="3"
                  value={bookingData.specialRequests}
                  onChange={(e) => setBookingData({...bookingData, specialRequests: e.target.value})}
                  className="w-full p-3 border-2 border-navy-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-transparent"
                ></textarea>
                <button 
                  onClick={() => {
                    if (bookingData.name && bookingData.dates && bookingData.package) {
                      setBookings([...bookings, {
                        date: bookingData.dates,
                        guest: bookingData.name,
                        status: 'pending',
                        package: bookingData.package
                      }]);
                      setBookingData({name: '', dates: '', package: '', specialRequests: ''});
                      alert('Prenotazione inviata! Ti farò sapere se sei degno/a della mia ospitalità 😄');
                    } else {
                      alert('Compila tutti i campi, altezza!');
                    }
                  }}
                  className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium shadow-md hover:shadow-lg"
                >
                  Invia Richiesta Reale
                </button>
              </div>
            </div>
          </div>
        );

      case 'regolamento':
        return (
          <div className="space-y-6">
            <div className="text-center bg-gradient-to-r from-red-500 via-pink-500 to-purple-600 text-white p-8 rounded-2xl relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-300/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="flex justify-center items-center mb-4">
                  <Award className="w-12 h-12 mr-3 text-yellow-300" />
                  <Crown className="w-16 h-16 text-yellow-400" />
                  <Award className="w-12 h-12 ml-3 text-yellow-300" />
                </div>
                <h1 className="text-3xl font-bold mb-2">📜 REGOLAMENTO UFFICIALE 📜</h1>
                <p className="text-pink-100 text-lg">
                  The Sunny Blonde House - Codice Penale Domestico<br />
                  {/* <span className="text-sm italic">(Approvato dal Consiglio dei Ministri dell'Aperitivo)</span> */}
                </p>
              </div>
            </div>

            {/* Articolo 1 - Gerarchia */}
            <div className="bg-gradient-to-r from-yellow-50 to-orange-50 p-6 rounded-xl border-2 border-orange-200">
              <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                <Crown className="w-6 h-6 mr-2 text-yellow-600" />
                ARTICOLO 1 - DELLA GERARCHIA SACRA
              </h2>
              <div className="space-y-3 text-navy-700">
                <p className="font-semibold">1.1 - La Padrona di Casa è l'essere supremo di questa dimora</p>
                <p>• Ogni sua parola è legge (anche quando contraddice la precedente)</p>
                <p>• Le sue decisioni sono inappellabili (tranne quando cambia idea)</p>
                
                <p className="font-semibold mt-4">1.2 - Ordine di successione al trono:</p>
                <p>• 1° Chi porta il vino migliore</p>
                <p>• 2° Chi cucina senza sporcare</p>
                <p>• 3° Chi pulisce senza essere richiesto (diretto al paradiso)</p>
                <p className="text-sm italic text-navy-500">*Il cane di casa, se presente, supera tutti in gerarchia</p>
              </div>
            </div>

            {/* Articolo 2 - Diritti e Doveri */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border-2 border-blue-200">
              <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                <Sparkles className="w-6 h-6 mr-2 text-blue-600" />
                ARTICOLO 2 - DIRITTI E DOVERI FONDAMENTALI
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-bold text-navy-700 mb-3">🎯 HAI IL DIRITTO DI:</h3>
                  <ul className="space-y-3 text-navy-600">
                    <li>• Respirare l'aria di questa casa (gratis!)</li>
                    <li>• Sederti dove vuoi (se libero e se ti è concesso)</li>
                    <li>• Esprimere le tue opinioni (se coincidono con quelle giuste)</li>
                    <li>• Ridere alle battute della Padrona (obbligatorio)</li>
                    <li>• Usare il bagno (previa autorizzazione scritta)</li>
                    <li>• Fare complimenti sulla casa (minimo 3 ogni ora)</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-bold text-navy-700 mb-3">⚖️ HAI IL DOVERE DI:</h3>
                  <ul className="space-y-3 text-navy-600">
                    <li>• Non giudicare il disordine (è "stile vissuto")</li>
                    <li>• Fingerti impressionato anche dalla pasta al pomodoro</li>
                    <li>• Non chiedere "che film vediamo?" (decisione reale)</li>
                    <li>• Portare qualcosa di buono (il cuore non basta)</li>
                    <li>• Ridere anche alle battute non divertenti</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Articolo 3 - Vita Sociale */}
            <div className="bg-gradient-to-r from-pink-50 to-red-50 p-6 rounded-xl border-2 border-pink-200">
              <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                <Users className="w-6 h-6 mr-2 text-pink-600" />
                ARTICOLO 3 - CODICE DI COMPORTAMENTO SOCIALE
              </h2>
              <div className="space-y-3 text-navy-700">
                <p className="font-semibold">3.1 - Principi Fondamentali della Casa:</p>
                <p>• La Padrona di casa ha sempre ragione</p>
                <p>• Se la Padrona di casa sbaglia, vedi comandamento #1</p>
                <p>• Il divertimento è garantito e mai rimborsato</p>
                <p>• Chi rompe, paga (e pulisce)</p>
                <p>• Gli orari sono indicativi (ma non troppo)</p>
                <p>• Le foto sui social sono permesse solo a pagamento</p>
                
                <p className="font-semibold mt-4">3.2 - Protocollo Fotografico:</p>
                <p>• Ogni momento deve essere documentato su IG ma solo dietro pagamento</p>
                <p>• Le foto brutte vanno eliminate immediatamente</p>
                <p>• "Fanne un'altra" può durare fino a 47 tentativi</p>

                <p className="font-semibold mt-4">3.3 - Regolamento Gossip:</p>
                <p>• Tutto quello che si dice qui, rimane qui (tranne le cose jugose)</p>
                <p>• I pettegolezzi vanno serviti con aperitivo</p>
                <p>• "Non dirlo a nessuno" significa "dillo solo ai tuoi migliori amici"</p>

                <p className="font-semibold mt-4">3.4 - Statuto delle Pulizie:</p>
                <p>• "Pulisco dopo" significa "mai"</p>
                <p>• Chi sporca, pulisce (in teoria)</p>
                <p>• La polvere è arredamento rustico</p>
                <p>• "È già pulido così" è sempre una risposta valida</p>

                <p className="font-semibold mt-4">3.5 - Codice del Maggiordomo Supremo:</p>
                <p>• Lavorare con il sorriso è obbligatorio (anche se forzato)</p>
                <p>• "Volontariato VIP" significa "schiavitù dorata"</p>
                <p>• Ogni "grazie" ricevuto vale come bonus (emotivo)</p>
                <p>• Il titolo di "Supremo" compensa tutto il lavoro svolto</p>
              </div>
            </div>

            {/* Articolo 4 - Tecnologia */}
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-xl border-2 border-purple-200">
              <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                <Sparkles className="w-6 h-6 mr-2 text-purple-600" />
                ARTICOLO 4 - REGOLAMENTO TECNOLOGICO AVANZATO
              </h2>
              <div className="space-y-3 text-navy-700">
                <p className="font-semibold">4.1 - Comandamento del Telecomando:</p>
                <p>• Chi tiene il telecomando ha il potere assoluto</p>
                <p>• "Cosa vuoi vedere?" è una domanda retorica</p>

                <p className="font-semibold mt-4">4.2 - Costituzione del WiFi:</p>
                <p>• La password è più segreta dei documenti della CIA</p>
                <p>• "Il wifi non va" = problema tuo, non nostro</p>
                <p>• Streammare in 4K contemporaneamente è atto di guerra</p>

                <p className="font-semibold mt-4">4.3 - Legge del Caricabatterie:</p>
                <p>• Ogni caricabatterie ha un proprietario (anche se uguale)</p>
                <p>• "Posso attaccare?" richiede permesso scritto</p>
                <p>• Il caricabatterie della Padrona è INTOCCABILE</p>
              </div>
            </div>

            {/* Articolo 5 - Pene e Sanzioni */}
            <div className="bg-gradient-to-r from-red-50 to-orange-50 p-6 rounded-xl border-2 border-red-200">
              <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                <Award className="w-6 h-6 mr-2 text-red-600" />
                ARTICOLO 5 - PENE E SANZIONI CREATIVE
              </h2>
              <div className="space-y-3 text-navy-700">
                <p className="font-semibold">5.1 - Sanzioni Minori (Reati Veniali):</p>
                <p>• Non rifare il letto → Dormi per terra</p>
                <p>• Lasciare briciole → Aspiri tutta la casa</p>
                <p>• Non chiudere il dentifricio → Ti lavi i denti col sapone</p>
                <p>• Dimenticare di portare il vino → Bevi solo acqua del rubinetto</p>

                <p className="font-semibold mt-4">5.2 - Sanzioni Maggiori (Reati Gravi):</p>
                <p>• Criticare la cucina della Padrona → Digiuno forzato</p>
                <p>• Rovinare il telecomando → Guardi solo la TV dei vicini</p>
                <p>• Svelare la password WiFi → Banishment digitale permanente</p>

                <p className="font-semibold mt-4">5.3 - Sanzioni Supreme (Alto Tradimento):</p>
                <p>• Dire che casa di mammà è meglio → Esilio immediato</p>
                <p>• Non ridere alle battute → Terapia comica forzata</p>
                <p>• Preferire l'ospitalità di altri → Damnatio memoriae</p>

                <div className="bg-gradient-to-r from-red-100 via-red-200 to-red-100 p-6 rounded-xl mt-4 border-2 border-red-300 shadow-lg">
                  <div className="text-center">
                    <p className="text-red-900 font-black text-xl mb-3 filter drop-shadow-md">
                      ⚠️ ATTENZIONE ⚠️
                    </p>
                    <p className="text-red-800 font-bold text-lg mb-2">
                      In caso di recidiva, si procede con la pena capitale:
                    </p>
                      <p className="text-red-900 font-black text-xl uppercase tracking-wide filter drop-shadow-lg">
                        NON ESSERE PIÙ INVITATI ALLE CENE EPICHE! 🍽️⚡
                      </p>
                  </div>
                </div>
              </div>
            </div>



            {/* Footer Regolamento */}
            <div className="relative mb-8 overflow-hidden rounded-xl">
              {/* Background con effetti multipli come l'header */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900"></div>
              <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/40 via-transparent to-blue-400/30"></div>
              <div className="absolute inset-0 bg-gradient-to-bl from-transparent via-yellow-500/15 to-blue-800/30"></div>
              
              {/* Effetti decorativi luminosi */}
              <div className="absolute top-4 left-8 w-24 h-24 bg-yellow-300/30 rounded-full blur-xl"></div>
              <div className="absolute bottom-6 right-12 w-20 h-20 bg-blue-300/40 rounded-full blur-lg"></div>
              <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-yellow-400/25 rounded-full blur-md"></div>
              <div className="absolute top-6 right-1/4 w-12 h-12 bg-blue-400/30 rounded-full blur-sm"></div>
              
              <div className="text-center relative z-20 p-8 text-white">
                {/* Corona con effetto glow */}
                <div className="relative mb-4">
                  <Crown className="w-16 h-16 mx-auto text-yellow-300 drop-shadow-2xl transform hover:scale-110 transition-transform duration-300" />
                  <div className="absolute inset-0 w-16 h-16 mx-auto bg-yellow-300/40 rounded-full blur-lg"></div>
                </div>
                
                {/* Titolo con gradiente elegante */}
                <h3 className="text-2xl lg:text-3xl font-black mb-4">
                  <span className="bg-gradient-to-r from-yellow-200 via-white to-blue-100 bg-clip-text text-transparent filter drop-shadow-2xl">
                    DISPOSIZIONI FINALI
                  </span>
                </h3>
                
                {/* Linea separatrice dorata */}
                <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-blue-400 mx-auto rounded-full mb-4"></div>
                
                <p className="text-white/90 mb-4 text-lg filter drop-shadow-lg">
                  Questo regolamento entra in vigore dal momento in cui metti piede in casa 
                  e rimane valido fino alla fine dei tempi (o fino a when I change my mind).
                </p>
                
                {/* Box firma con sfondo elegante */}
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 mb-4">
                  <p className="text-white/85 leading-relaxed">
                    Firmato: <span className="text-yellow-300 font-semibold">La Padrona di Casa Suprema</span><br />
                    Controfirmato: <span className="text-blue-200 font-semibold">Il Padrone di Casa (in subordine)</span><br />
                    Timbrato: <span className="text-yellow-200 font-semibold">Caffettiera di Stato</span>
                  </p>
                  <p className="text-yellow-200 italic text-lg font-medium filter drop-shadow-lg mt-2">
                    📜 "E il Biondo disse: 'Sia fatta la mia volontà, come in casa così in terrazza'" 📜
                  </p>
                </div>
                
                {/* Emoji con effetto scintillante */}
                <div className="text-3xl filter drop-shadow-lg pt-2">
                  <span className="inline-block transform hover:scale-125 transition-transform duration-200">👑</span>
                  <span className="inline-block transform hover:scale-125 transition-transform duration-200">⚖️</span>
                  <span className="inline-block transform hover:scale-125 transition-transform duration-200">🏠</span>
                  <span className="inline-block transform hover:scale-125 transition-transform duration-200">✨</span>
                  <span className="inline-block transform hover:scale-125 transition-transform duration-200">🍾</span>
                  <span className="inline-block transform hover:scale-125 transition-transform duration-200">📱</span>
                  <span className="inline-block transform hover:scale-125 transition-transform duration-200">🎭</span>
                  <span className="inline-block transform hover:scale-125 transition-transform duration-200">💫</span>
                </div>

              </div>
            </div>
          </div>
        );

      case 'contact':
        return (
          <div className="space-y-6">
            <h1 className="text-2xl font-bold text-navy-800 mb-6">Contatti del Padrone di Casa (sotto il Regno della Padrona)</h1>
            
            <div className="bg-white p-6 rounded-xl shadow-md border-2 border-navy-200">
              <div className="text-center mb-6">
                <Crown className="w-16 h-16 mx-auto text-yellow-500 mb-4" />
                <h2 className="text-xl font-bold text-navy-800">Sua Maestà le Blonde</h2>
                <p className="text-navy-600 italic">Proprietario ufficiale, re e responsabile del divertimento</p>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-center p-4 bg-navy-50 rounded-lg">
                  <Phone className="w-5 h-5 text-navy-600 mr-3" />
                  <div>
                    <div className="font-medium text-navy-800">Telefono Reale</div>
                    <div className="text-navy-600">Disponibile solo per emergenze VIP (e ordini della Padrona)</div>
                  </div>
                </div>
                
                <div className="flex items-center p-4 bg-navy-50 rounded-lg">
                  <Clock className="w-5 h-5 text-navy-600 mr-3" />
                  <div>
                    <div className="font-medium text-navy-800">Orari di Ricevimento</div>
                    <div className="text-navy-600">Quando mi va, come mi va</div>
                  </div>
                </div>
                
                <div className="flex items-center p-4 bg-navy-50 rounded-lg">
                  <Heart className="w-5 h-5 text-navy-600 mr-3" />
                  <div>
                    <div className="font-medium text-navy-800">Policy sui Regali</div>
                    <div className="text-navy-600">Sempre graditi, mai obbligatori (ma graditi)</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-navy-50 font-fredoka">
      <style jsx>{`
        .text-navy-50 { color: #f8fafc; }
        .text-navy-100 { color: #f1f5f9; }
        .text-navy-200 { color: #e2e8f0; }
        .text-navy-300 { color: #cbd5e1; }
        .text-navy-400 { color: #94a3b8; }
        .text-navy-500 { color: #64748b; }
        .text-navy-600 { color: #475569; }
        .text-navy-700 { color: #334155; }
        .text-navy-800 { color: #1e293b; }
        .text-navy-900 { color: #0f172a; }
        
        .bg-navy-50 { background-color: #f8fafc; }
        .bg-navy-100 { background-color: #f1f5f9; }
        .bg-navy-200 { background-color: #e2e8f0; }
        .bg-navy-300 { background-color: #cbd5e1; }
        .bg-navy-400 { background-color: #94a3b8; }
        .bg-navy-500 { background-color: #64748b; }
        .bg-navy-600 { background-color: #475569; }
        .bg-navy-700 { background-color: #334155; }
        .bg-navy-800 { background-color: #1e293b; }
        .bg-navy-900 { background-color: #0f172a; }
        
        .border-navy-200 { border-color: #e2e8f0; }
        .border-navy-300 { border-color: #cbd5e1; }
        
        .hover\\:bg-navy-100:hover { background-color: #f1f5f9; }
        .hover\\:bg-navy-800:hover { background-color: #1e293b; }
        .hover\\:bg-blue-100:hover { background-color: #dbeafe; }
        .hover\\:bg-blue-600:hover { background-color: #2563eb; }
        .hover\\:text-blue-700:hover { color: #1d4ed8; }
        .hover\\:border-navy-300:hover { border-color: #cbd5e1; }
        
        .focus\\:ring-navy-500:focus { --tw-ring-color: #64748b; }
      `}</style>
      
      <div className="max-w-6xl mx-auto p-4">
        {/* Header Unificato */}
        <div className="relative mb-8 overflow-hidden">
          {/* Background con effetti multipli */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-purple-900 to-navy-900"></div>
          <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/30 via-transparent to-blue-400/20"></div>
          <div className="absolute inset-0 bg-gradient-to-bl from-transparent via-pink-500/10 to-purple-600/20"></div>
          
          {/* Effetti decorativi */}
          <div className="absolute top-4 left-8 w-32 h-32 bg-yellow-300/20 rounded-full blur-xl"></div>
          <div className="absolute bottom-6 right-12 w-24 h-24 bg-blue-400/25 rounded-full blur-lg"></div>
          <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-pink-400/20 rounded-full blur-md"></div>
          
          {/* Contenuto principale */}
          <div className="relative z-20 text-center p-10 lg:p-16">
            <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center">
              
              {/* Sezione principale */}
              <div className="text-center lg:text-left flex-1">
                {/* Icone con effetto glow */}
                <div className="flex justify-center lg:justify-start items-center mb-8">
                  <div className="relative">
                    <Home className="w-16 h-16 mr-4 text-yellow-300 drop-shadow-2xl" />
                    <div className="absolute inset-0 w-16 h-16 mr-4 bg-yellow-300/30 rounded-full blur-md"></div>
                  </div>
                  <div className="relative">
                    <Crown className="w-20 h-20 text-yellow-400 drop-shadow-2xl transform hover:scale-110 transition-transform duration-300" />
                    <div className="absolute inset-0 w-20 h-20 bg-yellow-400/40 rounded-full blur-lg"></div>
                  </div>
                  <div className="relative">
                    <Sun className="w-16 h-16 ml-4 text-yellow-300 drop-shadow-2xl" />
                    <div className="absolute inset-0 w-16 h-16 ml-4 bg-yellow-300/30 rounded-full blur-md"></div>
                  </div>
                </div>
                
                {/* Titolo con effetti drammatici */}
                <div className="relative mb-6">
                  <h1 className="text-5xl lg:text-7xl font-black text-white mb-4 leading-tight">
                    <span className="bg-gradient-to-r from-yellow-200 via-white to-blue-100 bg-clip-text text-transparent filter drop-shadow-2xl">
                      The Sunny
                    </span>
                    <br />
                    <span className="bg-gradient-to-r from-blue-100 via-white to-yellow-200 bg-clip-text text-transparent filter drop-shadow-2xl">
                      Blonde House
                    </span>
                  </h1>
                  
                  {/* Sottotitolo elegante */}
                  <div className="relative">
                    <p className="text-xl lg:text-2xl font-bold text-white/90 mb-2 filter drop-shadow-lg">
                      App di Prenotazione VIP
                    </p>
                    <div className="w-32 h-1 bg-gradient-to-r from-yellow-400 to-blue-400 mx-auto lg:mx-0 rounded-full"></div>
                  </div>
                </div>
              </div>
              
              {/* Sezione stelle con stile premium */}
              <div className="text-center lg:text-right mt-8 lg:mt-0 lg:ml-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <span className="text-white/90 text-lg font-semibold block mb-4">Ospiti felici:</span>
                  <div className="flex justify-center lg:justify-end space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="relative">
                        <Star className="w-8 h-8 text-yellow-400 fill-current filter drop-shadow-lg transform hover:scale-110 transition-transform duration-200" />
                        <div className="absolute inset-0 w-8 h-8 bg-yellow-400/30 rounded-full blur-sm"></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Bordo luminoso in basso */}
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-400 via-blue-400 to-purple-500"></div>
        </div>

        {/* Navigation */}
        <div className="relative mb-6 overflow-hidden rounded-2xl">
          {/* Background con effetti leggeri */}
          <div className="absolute inset-0 bg-gradient-to-r from-white via-blue-50 to-purple-50"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-yellow-100/30 via-transparent to-blue-100/20"></div>
          
          {/* Effetti decorativi molto delicati */}
          <div className="absolute top-2 right-8 w-12 h-12 bg-yellow-200/20 rounded-full blur-lg"></div>
          <div className="absolute bottom-2 left-8 w-10 h-10 bg-blue-200/25 rounded-full blur-md"></div>
          
          {/* Contenuto */}
          <div className="relative z-10 p-6 backdrop-blur-sm">
            <div className="grid grid-cols-3 gap-4">
              <TabButton
                id="home"
                label="Home"
                icon={<Home className="w-6 h-6" />}
                active={activeTab === 'home'}
                onClick={setActiveTab}
              />
              <TabButton
                id="regolamento"
                label="Regolamento"
                icon={<Award className="w-6 h-6" />}
                active={activeTab === 'regolamento'}
                onClick={setActiveTab}
              />
              <TabButton
                id="contact"
                label="Contatti"
                icon={<Phone className="w-6 h-6" />}
                active={activeTab === 'contact'}
                onClick={setActiveTab}
              />
            </div>
          </div>
          
          {/* Bordo luminoso delicato */}
          <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-yellow-300/60 via-blue-300/60 to-purple-300/60"></div>
          
          {/* Shadow elegante */}
          <div className="absolute inset-0 shadow-lg rounded-2xl border border-white/50"></div>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-2xl shadow-lg p-6 border-2 border-navy-200">
          {renderContent()}
        </div>


        {/* <div className="bg-gradient-to-r from-pink-50 to-purple-50 p-6 rounded-xl border-2 border-navy-200 mt-6">
          <h3 className="font-bold text-navy-800 mb-3">Disclaimer Importante</h3>
          <p className="text-navy-600">
            Questa app è stata creata per puro divertimento dal Padrone di Casa. La Padrona di Casa si riserva il diritto di:
            cambiare idea, modificare i pacchetti, aggiungere regole assurde! Tutti i titoli nobiliari sono puramente decorativi e non riconosciuti da alcun regno (tranne quello della Sunny Blonde House).
            Il Padrone di Casa declina ogni responsabilità per decisioni prese dalla Padrona durante il suo regno!
          </p>
        </div> */}

        {/* Footer */}
        <div className="relative mt-6 overflow-hidden">
          
          {/* Background con effetti multipli */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-purple-900 to-navy-900"></div>
          <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/30 via-transparent to-blue-400/20"></div>
          <div className="absolute inset-0 bg-gradient-to-bl from-transparent via-pink-500/10 to-purple-600/20"></div>
          
          {/* Effetti decorativi ridotti */}
          <div className="absolute top-2 left-6 w-16 h-16 bg-yellow-300/20 rounded-full blur-xl"></div>
          <div className="absolute bottom-2 right-6 w-14 h-14 bg-blue-400/25 rounded-full blur-lg"></div>
          <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-pink-400/20 rounded-full blur-md"></div>
          
          {/* Contenuto principale */}
          <div className="relative z-20 text-center p-6">
            {/* Icone con effetto glow */}
            <div className="flex justify-center items-center mb-3">
              <div className="relative">
                <Heart className="w-7 h-7 text-red-400 mr-2 drop-shadow-2xl" />
                <div className="absolute inset-0 w-7 h-7 mr-2 bg-red-400/30 rounded-full blur-md"></div>
              </div>
              <div className="relative">
                <span className="text-xl lg:text-2xl font-black text-white drop-shadow-2xl">
                  <span className="bg-gradient-to-r from-yellow-200 via-white to-blue-100 bg-clip-text text-transparent">
                    Benvenuti nella casa più bionda del mondo!
                  </span>
                </span>
              </div>
              <div className="relative">
                <Heart className="w-7 h-7 text-red-400 ml-2 drop-shadow-2xl" />
                <div className="absolute inset-0 w-7 h-7 ml-2 bg-red-400/30 rounded-full blur-md"></div>
              </div>
            </div>
            
            {/* Copyright con stile elegante */}
            <div className="relative">
              <p className="text-base lg:text-lg font-bold text-white/90 filter drop-shadow-lg">
                © 2025 The Sunny Blonde House - Dove l'ospitalità incontra l'ironia ✨
              </p>
              <div className="w-24 h-0.5 bg-gradient-to-r from-yellow-400 to-blue-400 mx-auto rounded-full mt-2"></div>
            </div>
          </div>
          
          {/* Bordo luminoso in alto */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-400 via-blue-400 to-purple-500"></div>
          <div className='text-center text-white mb-4 px-4 filter drop-shadow-lg'>
              Questa app è stata creata per puro divertimento dal Padrone di Casa. La Padrona di Casa si riserva il diritto di: cambiare idea, modificare i pacchetti, cancellare prenotazioni senza preavviso e aggiungere regole incontestabili in qualsiasi momento! Tutti i titoli nobiliari sono puramente decorativi e non riconosciuti da alcun regno (tranne quello della Sunny Blonde House). Il Padrone di Casa declina ogni responsabilità per decisioni prese dalla Padrona durante il suo regno!
          </div>
        </div>

        {/* Package Selection Modal */}
        {selectedPackage && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl max-w-md w-full p-6 max-h-90vh overflow-y-auto">
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-xl font-bold text-navy-800">Conferma Prenotazione</h2>
                <button
                  onClick={() => setSelectedPackage(null)}
                  className="text-navy-400 hover:text-navy-600 text-2xl"
                >
                  ×
                </button>
              </div>
              
              <div className={`h-16 bg-gradient-to-r ${selectedPackage.color} rounded-lg flex items-center justify-center mb-4`}>
                <div className="text-white text-2xl">
                  {selectedPackage.icon}
                </div>
              </div>
              
              <h3 className="font-bold text-navy-800 text-lg mb-2">{selectedPackage.name}</h3>
              <p className="text-navy-600 text-sm italic mb-4">{selectedPackage.subtitle}</p>
              
              <div className="bg-navy-50 p-4 rounded-lg mb-4">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-medium text-navy-800">Pagamento richiesto:</span>
                  <span className="text-navy-600 font-bold">{selectedPackage.price}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-medium text-navy-800">Durata:</span>
                  <span className="text-navy-600">{selectedPackage.duration}</span>
                </div>
              </div>
              
              <div className="space-y-3 mb-6">
                <input
                  type="text"
                  placeholder="Il tuo nome da VIP"
                  className="w-full p-3 border-2 border-navy-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-transparent"
                />
                <input
                  type="date"
                  className="w-full p-3 border-2 border-navy-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-transparent"
                />
                <textarea
                  placeholder="Note speciali (richieste ragionevoli only!)"
                  rows="3"
                  className="w-full p-3 border-2 border-navy-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-transparent"
                ></textarea>
              </div>
              
              <div className="flex space-x-3">
                <button
                  onClick={() => setSelectedPackage(null)}
                  className="flex-1 bg-navy-200 text-navy-700 py-3 rounded-lg hover:bg-navy-300 transition-colors"
                >
                  Annulla
                </button>
                <button
                  onClick={() => {
                    alert(`Perfetto! Prenotazione per "${selectedPackage.name}" inviata! 🎉\n\nTi contatterò presto per confermare i dettagli (e per assicurarmi che tu sia degno/a di questo onore 😄)`);
                    setSelectedPackage(null);
                  }}
                  className="flex-1 bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition-colors shadow-md hover:shadow-lg"
                >
                  Conferma Prenotazione
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SunnyBlondeHouseApp;